import { Button, ButtonSizeType, ButtonStyleType } from '@into-discovery/browsewebshared';
import colorStyles from '@/styles/utils/variables.module.scss';
import React from 'react';

type Props = {
  isActive: boolean;
  onClick: (isTurnedOn: boolean) => void;
  activeText?: string;
  inactiveText?: string;
  activeAriaLabel?: string;
  inactiveAriaLabel?: string;
};

export default function ToggleButton({
  onClick = null,
  isActive,
  inactiveText = `Show more`,
  activeText = `Show less`,
  inactiveAriaLabel = `Show more`,
  activeAriaLabel = `Show less`,
}: Props) {
  const clickHandler = () => {
    if (onClick) {
      onClick(!isActive);
    }
  };
  return (
    <Button
      buttonID="show-more-universities"
      buttonAriaLabel={isActive ? activeAriaLabel : inactiveAriaLabel}
      buttonName="show more universities"
      buttonStyle={ButtonStyleType.Outline}
      buttonSize={ButtonSizeType.Medium}
      copyColor={colorStyles.primary}
      outlineColor={colorStyles.primary}
      backgroundColor={colorStyles.white}
      hoverBackgroundColor={colorStyles.primaryHover}
      activeBackgroundColor={colorStyles.primaryActive}
      onClick={clickHandler}
      buttonRole="button"
    >
      {isActive ? activeText : inactiveText}
    </Button>
  );
}
